import React from 'react';
import PropTypes from 'prop-types';
import { Heading, LinkButton } from '../../atoms';
import { ResponsiveImage } from '../ResponsiveImage';
import {
  Content,
  ButtonContainer,
  InfoContainer,
  ImageContainer,
  StyledSplitScreenPromo,
} from './styles.js';

const normalizeImageFirst = imageFirst =>
  typeof imageFirst === 'boolean'
    ? { desktop: imageFirst, mobile: imageFirst }
    : imageFirst;

export const SplitScreenPromo = ({
  title,
  contentBgColor,
  imageBgColor,
  fontColor,
  buttonText,
  urlTarget,
  children,
  image,
  imageFirst = false,
}) => (
  <StyledSplitScreenPromo>
    <Content fontColor={fontColor} bgColor={contentBgColor}>
      <Heading {...title} />
      <InfoContainer>{children}</InfoContainer>
      {buttonText && (
        <ButtonContainer>
          <LinkButton href={urlTarget}>{buttonText}</LinkButton>
        </ButtonContainer>
      )}
    </Content>
    <ImageContainer
      bgColor={imageBgColor}
      imageFirst={normalizeImageFirst(imageFirst)}
    >
      {image?.src && <ResponsiveImage {...image} />}
    </ImageContainer>
  </StyledSplitScreenPromo>
);

SplitScreenPromo.displayName = 'SplitScreenPromo';

SplitScreenPromo.propTypes = {
  title: PropTypes.object.isRequired,
  contentBgColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  buttonText: PropTypes.string,
  urlTarget: PropTypes.string,
  fontColor: PropTypes.string,
  image: PropTypes.object,
  imageBgColor: PropTypes.string,
  imageFirst: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      mobile: PropTypes.bool,
      desktop: PropTypes.bool,
    }),
  ]),
};
